import styled from '@emotion/styled';

export const ConferenceBoardBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8rem;
	max-width: 84.4rem;
	width: 100%;
	margin: 0 auto;
	padding-top: 8rem;
`;

export const ContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	@media screen and (max-width: 900px) {
		padding: 0 2rem;
	}
`;
export const ContentTitle = styled.p`
	color: #212529;
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
`;

export const BorderBox = styled.div`
	padding: 0.8rem 1.2rem;
	color: #495057;
	background-color: #f1f3f5;
	min-width: 11.8rem;
	border-radius: 999.9rem;
	text-align: center;
	white-space: nowrap;
`;
export const PointFont = styled.span`
	color: #47a3f3;
`;
export const ScheduleBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2.4rem;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightBold};
	line-height: 130%;
	letter-spacing: -0.6px;
	.danger {
		color: ${(props) => props.theme.colors.red600};
		font-size: ${(props) => props.theme.fontSize.sizeMd};
		font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	}
`;
export const ScheduleContent = styled.div<{ notCenter?: boolean }>`
	display: flex;
	gap: 0.8rem;
	align-items: ${(props) => (props.notCenter ? 'flex-start' : 'center')};
	.content {
		display: flex;
		flex-direction: column;
		gap: 0.8rem;
	}
`;

export const ImgMapBox = styled.div`
	height: 65.5rem;
	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
`;
